export const focusRing =
  'focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-brand-light/50 focus-visible:ring-offset-2'

const base = `inline-flex items-center justify-center gap-2 rounded-full font-semibold whitespace-nowrap min-h-[48px] px-6 text-base transition-[background-color,border-color,color,transform] duration-150 ease-out active:scale-[0.98] ${focusRing}`

export const buttonStyles = {
  primary: `${base} bg-brand text-white hover:bg-brand-dark`,
  whatsapp: `${base} bg-sage-dark text-white hover:bg-sage-darker`,
  outline: `${base} border-2 border-brand text-brand hover:bg-brand-tint`,
  outlineLight: `${base} border-2 border-white/80 text-white hover:bg-white/10`,
  light: `${base} bg-white text-brand-dark hover:bg-cream`,
}

export const container = 'mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8'
